// removed by extract-text-webpack-plugin
module.exports = {"balance":"_3oszWLg3y8LHt3AzlTP7nY","loading":"_351s9m3rv0vTXWlZBT2PLB","blink":"_3ukjs8YhEkGuOvpoavrZum"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/css/playerBalance.css
// module id = 900
// module chunks = 0